/*eslint-disable*/
import Api from './'

class OlympiadApi {

  static show(id) {
    return Api.axios.get('/olympiad/' + id)
        .then(response => response.data.olympiad);
  }

  static results(id) {
    return Api.axios.get('/olympiad/' + id + '/results')
        .then(response => response.data.olympiad);
  }

  static create(olympiad) {
    return Api.axios.post('/olympiad', olympiad)
        .then(response => response.data.olympiad);
  }

  static update(id, olympiad) {
    return Api.axios.put('/olympiad/' + id, olympiad)
        .then(response => response.data.olympiad);
  }

  static list(params, cancelToken = null) {
    return Api.axios.get('/olympiad', {params, cancelToken})
        .then(response => response.data.olympiads);
  }

  static pay(params) {
    return Api.axios.post('/olympiad/pay', {params})
        .then(response => response.data);
  }

  static getDefaultImageUrl() {
    return api.env.API_ENDPOINT + '/storage/user-files/avatars/olympiads/no-photo.svg';
  }

  static getStartSound (courseType) {
    return {
      id: 'startSound',
      src: api.env.API_ENDPOINT + `/storage/sounds/olympiads/start/${courseType}/Start.ogg`
    };
  }

  static getFinishSound () {
    return {
      id: 'finishSound',
      src: api.env.API_ENDPOINT + '/storage/sounds/olympiads/finish/Finish.ogg'
    };
  }
}

export default OlympiadApi;